import CircleTwoToneIcon from '@mui/icons-material/CircleTwoTone'
const Icon = (props: any) => {
  return <CircleTwoToneIcon {...props} />
}

export default Icon
